import { call, delay, put, race, take, takeLatest } from 'redux-saga/effects';

import { getJackpotHistory, getMiniGamesRewards } from '../../services/api';
import {
	JackpotHistoryData,
	jackpotHistoryFailure,
	jackpotHistoryRequest,
	jackpotHistorySuccess,
	MiniGamesRewardsData,
	miniGamesRewardsFailure,
	miniGamesRewardsRequest,
	miniGamesRewardsStartPolling,
	miniGamesRewardsStopPolling,
	miniGamesRewardsSuccess,
	miniGamesRewardsUpdateAmounts,
} from './miniGamesRewardsActions';

const POLL_INTERVAL = 60 * 1000;

function* getMiniGamesRewardsWorker() {
	try {
		const data: MiniGamesRewardsData = yield call(getMiniGamesRewards);

		if (data) {
			yield put(miniGamesRewardsSuccess(data));
		} else {
			yield put(miniGamesRewardsFailure('Mini games rewards not found'));
		}
	} catch (e: any) {
		console.log('[saga] mini games rewards error:', e);
		const msg = e?.message || e?.response?.data?.error || 'Failed to load mini games rewards';
		yield put(miniGamesRewardsFailure(msg));
	}
}

function* pollMiniGamesRewardsWorker() {
	while (true) {
		try {
			const data: MiniGamesRewardsData = yield call(getMiniGamesRewards);
			if (data) {
				yield put(miniGamesRewardsUpdateAmounts(data));
			}
		} catch (e: any) {
			console.log('[saga] poll mini games rewards error:', e);
		}
		yield delay(POLL_INTERVAL);
	}
}

function* getJackpotHistoryWorker() {
	try {
		const data: JackpotHistoryData = yield call(getJackpotHistory);

		if (data) {
			yield put(jackpotHistorySuccess(data));
		} else {
			yield put(jackpotHistoryFailure('Jackpot history not found'));
		}
	} catch (e: any) {
		console.log('[saga] jackpot history error:', e);
		const msg = e?.message || e?.response?.data?.error || 'Failed to load jackpot history';
		yield put(jackpotHistoryFailure(msg));
	}
}

export function* miniGamesRewardsRootSaga() {
	yield takeLatest(miniGamesRewardsRequest.type, getMiniGamesRewardsWorker);
	yield takeLatest(jackpotHistoryRequest.type, getJackpotHistoryWorker);

	yield takeLatest(miniGamesRewardsStartPolling.type, function* () {
		yield race({
			task: call(pollMiniGamesRewardsWorker),
			cancel: take(miniGamesRewardsStopPolling.type),
		});
	});
}
